<template lang="pug">
.div
  h2.title Orders Integration

  .form-section
    .input-container
      label.label Choose File Products
      input.input(ref="inputProducts" type="file" accept=".csv" autocomplete="ño" required)
      div(@click="readFileProducts") Read File Products
      div {{ messageProducts }}

    .input-container
      label.label Choose File
      input.input(ref="input" type="file" accept=".csv" autocomplete="ño" required)
      div(@click="readFile") Read File
      div {{ message }}
</template>

<script>
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'

export default {
  name: 'OrdersIntegration',

  data () {
    return {
      message: '',
      messageProducts: '',
      csv: '',
      csvProducts: '',
      products: {},
      titleNamesProducts: { product: 0, oldProduct: 1, person: 2, article: 3, design: 4, color1: 5, color2: 6, color3: 7, image1: 8, image2: 9, image3: 10, image4: 11, image5: 12, measurementsImage: 13, priceUnit: 14, priceThree: 15, priceWholesaler: 16, description: 17 },
      titleNames: { order: 0, orderNumber: 1, name: 2, address: 3, phone: 4, email: 5, location: 6, department: 7, methodPay: 8, status: 9, statusPay: 10, tip: 11, codeName: 12, adviser: 13, codePercent: 14, mp: 15, observation: 16, createdAt: 17, product: 18, size: 19, quantity: 20, value: 21, isWholesaler: 22, isDropshipping: 23, version: 24, dniDropshippingUser: 25, codeType: 26, discount: 27, realValue: 28, date: 29, year: 30, month: 31 },
      newSizes: {
        drill: {
          s: '28', m: '30', l: '32', xl: '34', xxl: '36'
        },
        shoes: {
          s: '37', m: '38', l: '39', xl: '40', xxl: '41'
        }
      }
    }
  },

  methods: {
    readFileProducts () {
      if (!this.$refs.inputProducts.files.length) return
      const file = this.$refs.inputProducts.files[0]
      const reader = new FileReader()
      this.messageProducts = 'Cargando...'
      reader.onload = () => {
        this.csvProducts = reader.result
        this.messageProducts = 'Cargado'
        this.csvToObjectProducts()
      }
      reader.readAsText(file)
    },

    csvToObjectProducts () {
      const _ = this.titleNamesProducts
      const lines = this.csvProducts.split('\r\n')

      lines.forEach((line, index) => {
        const values = line.split(';')
        if (!values[_.product]) return
        const product = { product: values[_.product], oldProduct: values[_.oldProduct], person: values[_.person], article: values[_.article], design: values[_.design], measurementsImage: values[_.measurementsImage], priceUnit: parseInt(values[_.priceUnit]), priceThree: parseInt(values[_.priceThree]), priceWholesaler: parseInt(values[_.priceWholesaler]), folder: 'products', subfolder: values[_.person], colors: [], images: [], priceSale: 0 }

        if (values[_.color1]) product.colors.push(values[_.color1])
        if (values[_.color2]) product.colors.push(values[_.color2])
        if (values[_.color3]) product.colors.push(values[_.color3])

        if (values[_.image1]) product.images.push(`${values[_.image1]}.jpg`)
        if (values[_.image2]) product.images.push(`${values[_.image2]}.jpg`)
        if (values[_.image3]) product.images.push(`${values[_.image3]}.jpg`)
        if (values[_.image4]) product.images.push(`${values[_.image4]}.jpg`)
        if (values[_.image5]) product.images.push(`${values[_.image5]}.jpg`)

        if (index) this.products[values[_.oldProduct]] = product
      })

      console.log('Productos Cargados')
    },

    readFile () {
      if (!this.$refs.input.files.length) return
      const file = this.$refs.input.files[0]
      const reader = new FileReader()
      this.message = 'Cargando...'
      reader.onload = () => {
        this.csv = reader.result
        this.message = 'Cargado'
        this.csvToObject()
      }
      reader.readAsText(file)
    },

    async csvToObject () {
      const _ = this.titleNames
      const lines = this.csv.split('\r\n')
      let order = {}

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i]
        const v = line.split(';')

        if (order.order !== v[_.order].toLowerCase()) {
          if (order.order) {
            const created = await this.newOrder(order)
            if (!created) throw new Error(`Error al crear la orden ${order.order}`)
          }

          order = { order: v[_.order].toLowerCase(), name: v[_.name], location: v[_.location], department: v[_.department], email: v[_.email], phones: [v[_.phone]], address: v[_.address], methodPay: v[_.methodPay], tip: parseInt(v[_.tip]), adviser: v[_.adviser], cart: [], isWholesaler: v[_.isWholesaler] === 'VERDADERO', isDropshipping: v[_.isDropshipping] === 'VERDADERO', dniDropshippingUser: v[_.dniDropshippingUser], status: v[_.status], mpCode: v[_.mpCode] || '', codeName: v[_.codeName], codeType: v[_.codeType], codePercent: parseInt(v[_.codePercent]), version: 0, createdAt: new Date(parseInt(v[_.createdAt])), observations: v[_.observation] ? [{ observation: v[_.observation], type: 'order', createdBy: '1018423770' }] : [] }
        }

        if (!this.products[v[_.product]]) {
          console.log(`%cEl producto ${v[_.product]} no se encuentra entre los productos subidos, error en la orden ${v[_.order]}`, 'background:red; color: white')
          throw new Error('----')
        }

        const product = Object.assign({}, this.products[v[_.product]])
        if (v[_.isDropshipping] === 'VERDADERO' || v[_.isWholesaler] === 'VERDADERO') {
          product.priceWholesaler = parseInt(v[_.value])
        } else {
          product.priceUnit = parseInt(v[_.value])
          product.priceThree = parseInt(v[_.value])
        }

        const productFind = order.cart.find(productCart => product.product === productCart.product)
        if (!productFind) {
          order.cart.push(product)
          product.quantityCart = []
          product.quantityCart.push(parseInt(v[_.quantity]))
          product.sizes = []
          const newSize = this.newSizes[product.article] && this.newSizes[product.article][v[_.size].trim()] ? this.newSizes[product.article][v[_.size].trim()] : v[_.size].trim()
          product.sizes.push(newSize)
        } else {
          const newSize = this.newSizes[product.article] && this.newSizes[product.article][v[_.size].trim()] ? this.newSizes[product.article][v[_.size].trim()] : v[_.size].trim()
          const sizeIndex = productFind.sizes.findIndex(size => size === newSize)

          if (!sizeIndex < 0) {
            productFind.quantityCart.push(parseInt(v[_.quantity]))
            productFind.sizes.push(newSize)
          } else {
            productFind.quantityCart[sizeIndex] += parseInt(v[_.quantity])
          }
        }
      }
    },

    async newOrder (order) {
      const mutation = gqlOrder.INTEGRATION

      const variables = { order }

      const response = await gql.mutate(mutation, variables, false)

      if (response) {
        console.log(`The product '${order.order}' ha sido creado`)
        return true
      } else {
        console.log(`%c------------- The order '${order.order}' ha tenido un error al crearse`, 'background: red; color: white')
        console.log(response.error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/integrations/Orders.vue